var findAfter = require('unist-util-find-after');
var visit = require('unist-util-visit-parents');
var MAX_HEADING_DEPTH = 6;
module.exports = plugin;
function plugin() {
  return transform;
}
function transform(tree) {
  var _loop = function _loop(depth) {
    visit(tree, function (node) {
      return node.type === 'heading' && node.depth === depth;
    }, sectionize);
  };
  for (var depth = MAX_HEADING_DEPTH; depth > 0; depth--) {
    _loop(depth);
  }
}
function sectionize(node, ancestors) {
  var start = node;
  var depth = start.depth;
  var parent = ancestors[ancestors.length - 1];
  var isEnd = function isEnd(node) {
    return node.type === 'heading' && node.depth <= depth || node.type === 'export';
  };
  var end = findAfter(parent, start, isEnd);
  var startIndex = parent.children.indexOf(start);
  var endIndex = parent.children.indexOf(end);
  var between = parent.children.slice(startIndex, endIndex > 0 ? endIndex : undefined);
  var section = {
    type: 'section',
    depth: depth,
    children: between,
    data: {
      hName: 'section'
    }
  };
  parent.children.splice(startIndex, section.children.length, section);
}